import { useEffect, useState } from 'react';
import { useAppSelector } from 'src/store';
import { useDispatch } from 'react-redux';
import { setFilteredTypes } from 'src/store/slices/knowledgeBaseSlices';

export const KnowledgeBaseFiltersList = () => {
  const { types, filteredTypes } = useAppSelector((s) => s.knowledgeBaseSlices);
  const [isHidden, setIsHidden] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsHidden(types.length === filteredTypes.length);
  }, [filteredTypes]);

  const remove = (type) => {
    const listOfTypes = types.filter((initialType) => {
      if (initialType.id === type.id) {
        return false;
      }

      return filteredTypes.some((filteredType) => initialType.id === filteredType.id);
    });

    if (!listOfTypes.length) {
      setIsHidden(true);
    }

    dispatch(setFilteredTypes({ types: listOfTypes.length ? listOfTypes : types }));
  };

  return isHidden ? null : (
    <div className={'flex flex-row gap-2.5 items-center'}>
      {filteredTypes.map((type) => {
        return (
          <div
            key={type.id}
            className={
              'flex flex-row items-center gap-[7px] text-xs text-ebony font-medium py-[6px] px-2.5 border border-[#E3E6E8] rounded-[50px] hover:bg-light'
            }
          >
            <div>
              <p>{type.title}</p>
            </div>
            <div className={'cursor-pointer'} onClick={() => remove(type)}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10"
                height="9"
                viewBox="0 0 10 9"
                fill="none"
              >
                <path d="M1 0.5L9 8.5M9 0.5L1 8.5" stroke="#E50505" strokeLinecap="round" />
              </svg>
            </div>
          </div>
        );
      })}
    </div>
  );
};
